<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'COMMUNITY'" [breadcrumb]="''" [count]=""
    icon="fa-search-location">
</app-breadcrumb>
<app-community-search [allowSelection]="false"></app-community-search>